import { ActionType, BaseAction, ActionLoadMainConfig, MainConfigResponseBody, ActionChangeLayerField } from '../../util/model';

const intitialState: MainConfigResponseBody = {
    UserInfo: {
        ID: '',
        Email: ''
    },
    PSDSettings: {
        L1Visibility: true,
        L2Visibility: true,
        RangeType:    'AUTO',
        PowerMin:     -150,
        PowerMax:     0
    },
    CameraSettings: {
        CurrentCamera: '',
        Cameras: [
            {
                Name: 'Default',
                CameraPos: [0, 0, 1000],
                TargetPos: [0, 0, 0]
            }
        ]
    }
}

export const layerConfigReducer = (state: MainConfigResponseBody = intitialState, action: BaseAction): MainConfigResponseBody => {
    if (action.type === ActionType.LOAD_ME_CONFIG) {
        const a = action as ActionLoadMainConfig;
        return {
            ...state,
            UserInfo:                  a.payload.UserInfo,
            PSDSettings:               a.payload.PSDSettings,
            CameraSettings:            a.payload.CameraSettings
        }
    } else if (action.type === ActionType.CHANGE_LAYER_FIELD) {
        const a = action as ActionChangeLayerField;
        const layer = state[a.payload.layerName];
        return {
            ...state,
            [a.payload.layerName]: {
                ...layer,
                [a.payload.fieldKey]: a.payload.fieldValue
            }
        }
    }
    return state;
}
